import React from 'react'
import { PAGE_ROUTES } from './routes'
import { pageCopy } from './pageCopy'

export const translateCopy = (value, lang) => {
  if (typeof value !== 'string') return value
  const key = value.trim()
  const translated = pageCopy[key]?.[lang === 'en' ? 0 : 1]
  return translated ? value.replace(key, translated) : value
}

const localizedPath = (path, lang) => {
  if (!path || !path.startsWith('/') || path.startsWith('/_assets/')) return path
  if (path === '/om-mig-2') return PAGE_ROUTES.about.paths[lang]
  const [pathname, suffix = ''] = path.split(/(?=[?#])/)
  const route = Object.values(PAGE_ROUTES).find((entry) => entry.paths?.da === pathname)
  return route?.paths?.[lang] ? route.paths[lang] + suffix : path
}

// Localize the JSX tree before it is rendered. This keeps the original page's
// layout, responsive classes, image order and interactions identical in all languages.
export function localizeTree(node, lang) {
  if (lang === 'da') return node
  if (typeof node === 'string') return translateCopy(node, lang)
  if (Array.isArray(node)) return node.map((child, index) => {
    const localized = localizeTree(child, lang)
    return React.isValidElement(localized) && localized.key == null
      ? React.cloneElement(localized, { key: index })
      : localized
  })
  if (!React.isValidElement(node)) return node

  const props = {}
  if (node.props.children !== undefined) props.children = localizeTree(node.props.children, lang)
  if (node.props.to) props.to = localizedPath(node.props.to, lang)
  if (node.props.href === '/_assets/bryllupskage-skema-dk.pdf' &&
      React.Children.toArray(node.props.children).some((child) =>
        React.isValidElement(child) && React.Children.toArray(child.props.children).some((label) =>
          React.isValidElement(label) && label.props.children === 'Download formularen'
        )
      )) {
    props.href = lang === 'en' ? '/_assets/bryllupskage-skema-eng.pdf' : '/_assets/bryllupskage-skema-de.pdf'
  }
  if (node.props.alt) props.alt = translateCopy(node.props.alt, lang)
  if (node.props.title) props.title = translateCopy(node.props.title, lang)
  if (node.props['aria-label']) props['aria-label'] = translateCopy(node.props['aria-label'], lang)
  if (node.type?.name === 'SeoHead' || node.type?.name === 'ReviewsSlider' || node.type?.name === 'CakeInquiryForm' || node.type?.name === 'LightboxGallery') props.lang = lang
  if (node.type?.name === 'SeoHead' && !node.props.pageId) {
    props.title = lang === 'en' ? 'Page not found (404) - Fanø Chokolade' : 'Seite nicht gefunden (404) - Fanø Chokolade'
    props.description = lang === 'en' ? 'The page you are looking for does not exist or has been moved.' : 'Die gesuchte Seite wurde nicht gefunden oder wurde verschoben.'
  }
  return React.cloneElement(node, props)
}
